import RoofSnapApiClient from './roofSnapApiClient';

const baseUrl = 'notificationtemplates';

class NotificationTemplatesClient extends RoofSnapApiClient {
    async getNotificationTemplates(params) {
        const { queryParams } = params;
        try {
            const url = `${baseUrl}${queryParams}`;
            return await super.get(url);
        } catch (error) {
            return Promise.reject(error);
        }
    }
}

export default NotificationTemplatesClient;
